// Page one can judge membership only inside its own activity-time window.
export function mergeConversationRefresh(previousIds, items, previousEntities, entities) {
  const received = new Set(items.map(item => item.id));
  const times = items.map(item => Date.parse(item.last_activity_at)).filter(Number.isFinite);
  const boundary = times.length ? Math.min(...times) : null;
  const retained = previousIds.filter(id => received.has(id) || boundary == null
    || !Number.isFinite(Date.parse(previousEntities[id]?.last_activity_at))
    || Date.parse(previousEntities[id]?.last_activity_at) < boundary);
  return [...new Set([...retained, ...received])].filter(id => entities[id]).sort((a, b) =>
    (Date.parse(entities[b]?.last_activity_at) || 0) - (Date.parse(entities[a]?.last_activity_at) || 0));
}
